import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Bell, Trash2, CheckCircle2, AlertTriangle, FileText, ClipboardCheck, Info } from "lucide-react";
import { toast } from "sonner";

const PRIO_BORDER = { bassa: "border-l-slate-400", media: "border-l-blue-500", alta: "border-l-amber-500", critica: "border-l-rose-500" };
const typeIcon = (t) => t === "alert" ? AlertTriangle : t === "audit_assegnato" ? ClipboardCheck : t === "relazione_reminder" ? FileText : Info;

export default function Notifiche() {
  const navigate = useNavigate();
  const [notifs, setNotifs] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ limit: 200 });
      if (filter === "unread") params.set("letto", "false");
      else if (filter === "read") params.set("letto", "true");
      const r = await api.get(`/notifications?${params.toString()}`);
      setNotifs(r.data || []);
    } finally { setLoading(false); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [filter]);

  const markAll = async () => {
    await api.patch("/notifications/leggi-tutte");
    toast.success("Tutte segnate come lette");
    load();
  };

  const del = async (n) => {
    await api.delete(`/notifications/${n.id}`);
    load();
  };

  const click = async (n) => {
    if (!n.letto) await api.patch(`/notifications/${n.id}/leggi`);
    if (n.link) navigate(n.link);
    else load();
  };

  return (
    <div className="space-y-6 ih-anim-in" data-testid="notifiche-page">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-2 flex items-center gap-1.5"><Bell className="h-3 w-3" /> Centro notifiche</div>
          <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-light">Le tue <span className="font-medium">notifiche</span></h1>
        </div>
        <button onClick={markAll} data-testid="mark-all-btn" className="px-4 py-2 rounded-full border border-border text-sm flex items-center gap-2"><CheckCircle2 className="h-4 w-4" /> Segna tutte lette</button>
      </div>

      <div className="ih-glass rounded-2xl p-1 inline-flex gap-1">
        {[["all", "Tutte"], ["unread", "Non lette"], ["read", "Lette"]].map(([k, l]) => (
          <button key={k} onClick={() => setFilter(k)} data-testid={`filter-${k}`} className={`px-4 py-1.5 rounded-full text-xs font-medium transition-colors ${filter === k ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>{l}</button>
        ))}
      </div>

      <div className="ih-glass rounded-2xl p-6">
        {loading ? "Caricamento…" : notifs.length === 0 ? (
          <div className="ih-empty-state"><div className="ih-empty-state-icon"><svg width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg></div><h3 className="text-lg font-semibold mb-1">Nessuna notifica</h3><p className="text-sm text-muted-foreground max-w-md">Le notifiche operative compariranno qui quando il sistema rileverà eventi rilevanti.</p></div>
        ) : (
          <div className="space-y-1.5">
            {notifs.map((n) => {
              const Icon = typeIcon(n.tipo);
              return (
                <div key={n.id} data-testid={`notif-row-${n.id}`} className={`rounded-xl border border-border/60 border-l-4 p-4 flex items-start gap-3 ${PRIO_BORDER[n.priorita] || "border-l-transparent"} ${!n.letto ? "bg-accent/20" : ""}`}>
                  <Icon className="h-4 w-4 mt-0.5 text-muted-foreground" />
                  <div onClick={() => click(n)} className="flex-1 min-w-0 cursor-pointer">
                    <div className="font-medium text-sm">{n.titolo}</div>
                    <div className="text-xs text-muted-foreground">{n.messaggio}</div>
                    <div className="text-[10px] text-muted-foreground/70 mt-1">{new Date(n.created_at).toLocaleString("it-IT")} · {n.priorita}</div>
                  </div>
                  {!n.letto && <span className="h-2 w-2 rounded-full bg-lavender-500 mt-2" />}
                  <button onClick={() => del(n)} className="h-8 w-8 rounded-lg hover:bg-rose-100 dark:hover:bg-rose-900/30 text-rose-500 flex items-center justify-center"><Trash2 className="h-3.5 w-3.5" /></button>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
